/**
 * Bulk adverse-check job poll interval (ms) between getBulkAdverseCheckJob calls.
 * Kept well under the Playwright SAMPLE_OIG 4-row / 4s SLA.
 */
export const BULK_ADVERSE_CHECK_POLL_INTERVAL_MS = 250;
